import { Component, OnInit } from '@angular/core';
import {IObject} from "../../shared/models/models";
import {ActivatedRoute} from "@angular/router";
import {ServerService} from "../../shared/services/server.service";
import {EventService} from "../../shared/services/event.service";

@Component({
  selector: 'app-page-object',
  templateUrl: './page-object.component.html',
  styleUrls: ['./page-object.component.scss']
})
export class PageObjectComponent implements OnInit {

  object: IObject = null;
  loading: boolean = false;
  editMode: boolean = true;

  constructor(private route: ActivatedRoute,
              private serverService: ServerService) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.loading = false;
      this.object = null;
      if (params.id > 0) {
        this.serverService.getObject(params.id).then(res => {
          this.object = res;
          this.loading = true;
        });
      } else {
        this.object = {
          id: 0,
          name: "",
          development_start_date: new Date().getTime(),
          development_end_date: new Date().getTime(),
          region: null,
          city: null,
          finances: null,
          latitude: 0,
          longitude: 0,
          investments: {
            own_investments: 0,
            bd_investments: 0,
            own_investments2: 0,
            bd_investments2: 0,
            implementation_amount: 0
          },
          developer: {
            responsible: null,
            general_contractor: null,
            author_supervision: null,
            technical_supervision: null,
            supervisor: null,
            authorized_organization: null
          },
          spots: [],
          portalID: 1,
          own_investments2: 0,
          investAmounts: [],
          cadastral: null

        }
        this.editMode = true;
        this.loading = true;
      }
    });

  }

}
